import {useForm} from "react-hook-form"
import {Role} from "dto/Role"
import {useCallback, useEffect} from "react"
import {Composites} from "pages/role/Composites"
import {useNavigate, useParams} from "react-router-dom"
import {useFindRoleByName, useUpdateRole} from "hooks/query/role-query"
import {NotificationType, showNotification} from "common/Notification"

export function UpdateRoleForm() {
    const navigate = useNavigate()
    const {name} = useParams()
    const {data: role} = useFindRoleByName(name)
    const updateMutate = useUpdateRole()

    const {register, setValue, getValues, watch, handleSubmit} = useForm<Role>()

    useEffect(() => {
        if (!role) return
        setValue("name", role.name)
        setValue("description", role.description)
        setValue("composite", role.composite)
    }, [role, setValue])

    const toggleComposite = useCallback(() => {
        setValue("composite", !watch("composite"))
    }, [setValue, watch])

    const submit = (values: Role) => {
        console.log("values: ", values)
        const role = {
            name: values.name,
            description: values.description
        }
        updateMutate.mutate(role, {
            onSuccess: () => {
                showNotification("롤 정보를 수정하였습니다", NotificationType.SUCCESS)
            },
            onError: () => {
                showNotification("롤 정보수정이 실패하였습니다")
            }
        })
    }

    const composite = watch("composite")
    if (!role) return null
    return (
        <form onSubmit={handleSubmit(submit)}>
            <div className="mt40 ml20">
                <div className="gray-label is-size-85">Role ID</div>
                <div className="">
                    <input className="input is-gray" type="text" placeholder="id입력"
                           {...register("name",)}
                           readOnly={true}
                    />
                </div>
            </div>
            <div className="mt20 ml20">
                <div className="gray-label is-size-85">메모</div>
                <div className="">
                   <textarea className="textarea" placeholder="" rows={3}
                             {...register("description")} />
                </div>
            </div>
            <div className="mt30 ml20">
                <button className="button is-purple2">확인</button>
                <div className="is-clickable button ml-2" onClick={() => navigate("/role/list")}>목록으로</div>
            </div>
            <div className="hr-line-dashed mt30"/>
            <div className="mt20 ml20">
                <div className="gray-label is-size-85">Role 합성</div>
                <div className="gray-boxline">
                    <div
                        className={`btn-check is-clickable ${getValues("composite") ? "check-on" : ""}`}
                        onClick={() => toggleComposite()}>
                        <div className="btn-select"></div>
                    </div>
                </div>
            </div>

            {composite && (
                <Composites roleName={role.name}/>
            )}
        </form>
    )
}